import { ScorecardTemplateEditor } from '@/components/shared/interview-plan/stage/activity/activity-sections/schedule-interview/score-card/ScorecardTemplateEditor';

export const Scorecard = ({
  formRef,
  questions = [],
  defaultScorecardParams = {},
  scorecardData = {},
  scorecardRequired = true,
  onScorecardRequiredChange = null,
}) => {
  return (
    <ScorecardTemplateEditor
      ref={formRef}
      questions={questions}
      defaultScorecardParams={defaultScorecardParams}
      scorecardData={scorecardData}
      note="This is the recommended scorecard template. You can customize it but changes will only apply to this assessment."
      scorecardRequired={scorecardRequired}
      onScorecardRequiredChange={onScorecardRequiredChange}
    />
  );
};
